import { PORTFOLIO_REFETCH_POLICY } from 'config/RefetchPolicies'
import { SubgraphType } from 'config/subgraph'
import { useSubgraphConfig } from 'hooks/useSubgraphConfig'
import { GetPortfolioV2PoolsQuery, useGetPortfolioV2PoolsQuery } from 'queries/v2/generated'
import { useMemo } from 'react'

export type V2PoolData = GetPortfolioV2PoolsQuery['pairs'][number]

export function useV2PoolsData(poolIds: string[], options?: { enabled?: boolean }) {
  const subgraphConfig = useSubgraphConfig(SubgraphType.V2)

  // Convert pool IDs to lowercase for subgraph query
  const lowerCaseIds = useMemo(() => poolIds.map((id) => id.toLowerCase()), [poolIds])

  const v2PoolsQuery = useGetPortfolioV2PoolsQuery(
    subgraphConfig,
    {
      ids: lowerCaseIds,
    },
    {
      enabled: poolIds.length > 0 && options?.enabled !== false,
      ...PORTFOLIO_REFETCH_POLICY,
    }
  )

  // Create a map of poolId -> poolData for easy lookup
  const poolsMap = useMemo(() => {
    const map: Record<string, V2PoolData> = {}
    v2PoolsQuery.data?.pairs.forEach((pool) => {
      map[pool.id.toLowerCase()] = pool
    })
    return map
  }, [v2PoolsQuery.data])

  return {
    ...v2PoolsQuery,
    data: poolsMap,
  }
}
